import { Outlet, useLocation } from 'react-router-dom';
import { inject, observer, PropTypes as MobXPropTypes } from 'mobx-react';
import BackButton from 'components/BackButton';
import { ROUTE_PATHS } from 'routes/constants';

const PaymentObligations = () => {
  const location = useLocation();

  return (
    <section className={'right-section'}>
      {location.pathname !== ROUTE_PATHS.PAYMENT_OBLIGATIONS && <BackButton />}
      <Outlet />
    </section>
  );
};

PaymentObligations.propTypes = {
  paymentObligationsStore: MobXPropTypes.observableObject
};

export default inject((stores) => ({
  paymentObligationsStore: stores.paymentObligationsStore
}))(observer(PaymentObligations));
